import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { ShieldAlert } from "lucide-react";

export default function NoAccess() {
  return (
    <div className="mx-auto max-w-3xl px-4 sm:px-6 lg:px-8 py-10" data-testid="no-access-page">
      <Card>
        <CardHeader>
          <CardTitle className="text-xl">Access required</CardTitle>
        </CardHeader>
        <CardContent className="space-y-4">
          <Alert data-testid="no-access-alert">
            <ShieldAlert className="h-4 w-4" />
            <AlertTitle>No reports assigned</AlertTitle>
            <AlertDescription>
              Your account is active, but you don’t have access to any reports yet.
              Please ask an administrator to enable at least one report permission
              (Executive, Sales, Practitioner, Clinic) and optionally Data Explorer.
            </AlertDescription>
          </Alert>

          <div className="text-sm text-muted-foreground" data-testid="no-access-hint">
            You can still open <span className="font-medium text-foreground">Settings</span> from the header.
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
